class Tooltips {
	constructor() {
		this.buttons = document.getElementsByClassName('tooltiped');
		this.tooltips = [];
		let i = 0;
		for (const button of this.buttons) {
			button.index = i;
			button.addEventListener('mouseleave', this.cursorLeave.bind(this));
			button.addEventListener('mouseenter', this.cursorEnter.bind(this));
			const div = document.createElement('div');
			div.classList.add('tooltip');
			if (button.classList.contains('tool-right')) {
				div.classList.add('tooltip-right');
			}
			if (button.classList.contains('special-right')) {
				div.classList.add('specialTip-right');
			}
			if (button.classList.contains('styled')) {
				div.classList.add('styled');
			}
			div.textContent = button.dataset.tooltip;
			this.tooltips.push({ tooltip: div, target: button });
			document.body.appendChild(div);
			i++;
		}
	}

	cursorLeave(event) {
		this.hideToolTip(event.currentTarget.index);
	}

	cursorEnter(event) {
		if (event.type.indexOf('touch') == -1) {
			this.showToolTip(event.currentTarget.index);
		}
	}

	hideToolTip(index) {
		this.tooltips[index].tooltip.classList.remove('shown');
	}

	showToolTip(index) {
		const targetPosition = this.tooltips[index].target.getBoundingClientRect();
		const targetWidth = this.tooltips[index].target.offsetWidth;
		const targetHeight = this.tooltips[index].target.offsetHeight;
		const topOffset = this.tooltips[index].tooltip.classList.contains('tooltip-right') ? targetHeight / 2 : -10;
		const leftOffset = this.tooltips[index].tooltip.classList.contains('tooltip-right')
			? targetWidth + 10
			: targetWidth / 2;
		this.tooltips[index].tooltip.style.top = `${Math.round(targetPosition.top + topOffset)}px`;
		this.tooltips[index].tooltip.style.left = `${Math.round(targetPosition.left + leftOffset)}px`;
		this.tooltips[index].tooltip.classList.add('shown');
	}
}
export default Tooltips;
